import { useState } from "react"
import Input from "../Input"
import MyModal from "../MyModal"
import { banClient } from "../../services/tsQueryApis"
import { toast } from "react-toastify"
import { useSocket } from "../../contexts/SocketContext"

const BanClientModal = ({ client }) => {
    const [isOpen, setIsOpen] = useState(false)
    const { isConnected, sendMessage } = useSocket()

    const toggleModal = () => {
        setIsOpen(!isOpen)
    }

    return (
        <>
            <button onClick={toggleModal} className="styled-button danger px-5">
                بن
            </button>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} width="400px" height="240px">
                <form
                    className="mt-5 flex flex-col gap-5"
                    onSubmit={(event) => {
                        event.preventDefault()
                        const form = new FormData(event.target)
                        const banReason = form.get("reason")
                        const banTime = form.get("time")
                        sendMessage("ban", { banReason, banTime, clid: client.clid })
                    }}
                >
                    <div>
                        <Input label="علت" type="text" placeholder="reason" name="reason" />
                    </div>
                    <div>
                        <Input
                            label="مدت زمان بن به ثانیه"
                            type="number"
                            placeholder="برای نامحدود خالی بزار"
                            name="time"
                        />
                    </div>
                    <button type="submit" className="styled-button w-full">
                        بن کردن کلاینت
                    </button>
                </form>
            </MyModal>
        </>
    )
}

export default BanClientModal
